import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from '@common-fe/common-fe';

import { useDocumentOcrStore, useMyMoneyFormStore, useMyMoneyStore } from '@/modules/UseMyMoney/stores';
import { ClaimSummaryField, UseMyMoneyOption } from '@/modules/UseMyMoney/UseMyMoney.types';

interface Props {
  hasValidDate?: boolean;
}

const useClaimSummarySetupFields = ({ hasValidDate }: Props) => {
  const { t } = useTranslation();
  const { values } = useMyMoneyFormStore();
  const { useMyMoneyOption } = useMyMoneyStore();
  const { ocrDocument } = useDocumentOcrStore();

  const fields = useMemo((): Option[] => {
    if (useMyMoneyOption === UseMyMoneyOption.REIMBURSE_MYSELF || useMyMoneyOption === UseMyMoneyOption.PAY_A_PROVIDER) {
      const provider = ocrDocument?.providers?.find((provider) => provider?.id === values?.providerId);

      return [
        {
          key: ClaimSummaryField.AMOUNT,
          title: t('Amount'),
          value: values?.amount,
        },
        {
          key: ClaimSummaryField.PROVIDER,
          title: t('Retailer/Provider'),
          value: provider?.name && (provider?.address?.line1 || useMyMoneyOption === UseMyMoneyOption.REIMBURSE_MYSELF)
            ? provider?.name
            : '',
        },
        {
          key: ClaimSummaryField.SERVICE_FOR,
          title: t('Service For'),
          value: values?.patientId,
        },
        {
          key: ClaimSummaryField.DATE_OF_SERVICE,
          title: t('Date of Service'),
          value: hasValidDate ? values?.dateOfService : '',
        },
        {
          key: ClaimSummaryField.SERVICE_DESCRIPTION,
          title: t('Service Description'),
          value: values?.serviceId,
        },
      ];
    }

    if (useMyMoneyOption === UseMyMoneyOption.HSA_WITHDRAWAL) {
      return [
        {
          key: ClaimSummaryField.AMOUNT,
          title: t('Amount'),
          value: values?.amount,
        },
      ];
    }

    return [];
  }, [useMyMoneyOption, t, values, hasValidDate, ocrDocument?.providers]);

  return {
    fields,
  };
};

export default useClaimSummarySetupFields;
